import * as apis from 'api';
import APIGateway from 'api/gateway';
import { bindAPI, makePatchedGateway } from 'api/patchedGateway';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectToken } from 'slices/auth';

export const useAPI = () => {
  const token = useSelector(selectToken);
  const navigate = useNavigate();

  return useMemo(() => {
    const patchedAPIGateway = makePatchedGateway(APIGateway, {
      authorization: token ? `Bearer ${token}` : null,
      onError: (_status, options) => {
        // Deliberate: an errored view bounces back to the previous screen instead of
        // stranding the user on broken data (e.g. PATCHing a missing membership 404s —
        // see the guard in slices/chats updateMembership). `silent` callers (e.g. the
        // background keep-alive ping) opt out, otherwise every failed poll would navigate.
        if (!options.silent) navigate(-1);
      },
    });

    return Object.fromEntries(
      Object.entries(apis).map(([name, api]) => [name, bindAPI(api, patchedAPIGateway)])
    );
  }, [token, navigate]);
};
